<template>
<div class="organizationWithdraw">
  <h1 class="title grey--text pt-2">机构提现</h1>
  <div>
    <v-card
      v-for="(orgWithdrawRecord, orgWithdrawRecordIndex) in orgWithdrawRecords" v-bind:key="`orgWithdrawRecord-${orgWithdrawRecordIndex}`"
      :class="`ma-5 d-flex`"
    >
      <v-layout column>
        <div class="px-5 pt-5">
          <v-flex>
            <div class="caption grey--text">{{ orgWithdrawRecord.organization }}</div>
          </v-flex>
          <v-flex>
            <div class="title">{{ orgWithdrawRecord.amount_fen_req / 100 }}元</div>
          </v-flex>
          <div class="">
            <span class="caption"><v-icon small>access_time</v-icon> {{ dateFormat(new Date(orgWithdrawRecord.request_time), "MM/dd/yyyy HH:mm:ss") }}</span>
          </div>
          <div class="">
            <span class="caption">{{ orgWithdrawRecord.withdraw_status }}</span>
          </div>
          <v-divider class="mt-3"></v-divider>
          <v-flex class='d-flex flex-row justify-end py-2'>
            <v-btn
              v-if="[1,2].includes(orgWithdrawRecord.withdraw_status_code)"
              color="green"
              outlined
              rounded
              small
              @click="approveAndFulfillOrgWithdrawRequest(orgWithdrawRecord.org_withdraw_id)"
            >
              审核通过
              <v-icon small>check_circle</v-icon>
            </v-btn>
            <span
              v-if="[3].includes(orgWithdrawRecord.withdraw_status_code)"
              class="green--text caption"
            >
              <v-icon color="green">check_circle</v-icon>
              完成提现:  {{ dateFormat(new Date(orgWithdrawRecord.withdraw_time), "MM/dd/yyyy HH:mm:ss") }}
            </span>
          </v-flex>
        </div>
      </v-layout>
    </v-card>
  </div>
</div>
</template>

<script>
import FinanceService from '@/services/FinanceService'
import consola from 'consola'
import format from 'date-fns/format'

export default {
  components: {
  },
  data () {
    return {
      orgWithdrawRecords: []
    }
  },
  async mounted () {
    consola.info('#Page: OrganizationWithdraw')

    // get account role list
    this.orgWithdrawRecords = await this.getOrgWithdrawRecords([1, 2, 3])
    consola.log('\nRetrieved organization records: ', this.orgWithdrawRecords)
  },
  methods: {
    async getOrgWithdrawRecords (withdrawStatusCodes) {
      const res = await FinanceService.getOrgWithdrawRecords(withdrawStatusCodes)
      return res.data
    },
    async approveAndFulfillOrgWithdrawRequest (orgWithdrawId) {
      const res = await FinanceService.approveAndFulfillOrgWithdrawRequest(orgWithdrawId)
      consola.info(`审核结果: ${res.data.msg}`)
      if (parseInt(res.data.error_code) === 0) { this.$router.go() }
    },
    dateFormat (timeDate, formatString) {
      return format(timeDate, formatString)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
